import type { ThemeColorName } from '@examdojo/styles';
import { TRIANGLE_COLORS } from '../shapes/triangle/triangle.model';
import { RECTANGLE_EDGE_COLORS } from '../shapes/rectangle/rectangle.model';

/** Neutral fallback when coloring is disabled */
export const NEUTRAL_COLOR: ThemeColorName = 'neutral';

/**
 * Get the color for a triangle property.
 */
export function getTriangleColor(property: string, labelColoring: boolean): ThemeColorName {
  if (!labelColoring) {
    return NEUTRAL_COLOR;
  }
  return TRIANGLE_COLORS[property] ?? NEUTRAL_COLOR;
}

/**
 * Get the color for a rectangle edge by index.
 */
export function getRectangleEdgeColor(edgeIndex: number, labelColoring: boolean): ThemeColorName {
  if (!labelColoring) {
    return NEUTRAL_COLOR;
  }
  return RECTANGLE_EDGE_COLORS[edgeIndex % RECTANGLE_EDGE_COLORS.length];
}
